<template>
  <el-container class="app-layout">
    <el-aside :width="asideWidth" class="app-aside" :class="{ 'is-collapse': isCollapse }">
      <div class="brand">
        <span v-if="!isCollapse">投研系统</span>
        <span v-else class="brand-short">投</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :collapse-transition="false"
        class="side-menu"
        background-color="#1f2d3d"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        @select="$emit('select', $event)"
      >
        <el-menu-item index="home">
          <i class="el-icon-s-home" />
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="fund">
          <i class="el-icon-s-data" />
          <span slot="title">基金重仓</span>
        </el-menu-item>
        <el-menu-item index="fund-industry">
          <i class="el-icon-s-opportunity" />
          <span slot="title">重仓行业</span>
        </el-menu-item>
        <el-menu-item index="kline">
          <i class="el-icon-search" />
          <span slot="title">日K查询</span>
        </el-menu-item>
        <el-menu-item index="system-recommend">
          <i class="el-icon-magic-stick" />
          <span slot="title">系统推荐</span>
        </el-menu-item>
        <el-menu-item index="window-ranking">
          <i class="el-icon-data-board" />
          <span slot="title">波段雷达</span>
        </el-menu-item>
        <el-menu-item index="backtest">
          <i class="el-icon-data-analysis" />
          <span slot="title">策略回测</span>
        </el-menu-item>
        <el-menu-item index="backtest-forecast">
          <i class="el-icon-magic-stick" />
          <span slot="title">策略预测</span>
        </el-menu-item>
        <el-menu-item index="trend-king">
          <i class="el-icon-top-right" />
          <span slot="title">趋势为王</span>
        </el-menu-item>
        <el-menu-item index="td9">
          <i class="el-icon-s-flag" />
          <span slot="title">神奇九转</span>
        </el-menu-item>
        <el-menu-item index="ma-deviation">
          <i class="el-icon-odometer" />
          <span slot="title">年线偏离</span>
        </el-menu-item>
        <el-menu-item index="sim-trading">
          <i class="el-icon-wallet" />
          <span slot="title">模拟实盘</span>
        </el-menu-item>
        <el-menu-item index="industry">
          <i class="el-icon-s-grid" />
          <span slot="title">行业行情</span>
        </el-menu-item>
        <el-menu-item index="industry-trend">
          <i class="el-icon-data-line" />
          <span slot="title">行业趋势</span>
        </el-menu-item>
        <el-menu-item index="stock-trend">
          <i class="el-icon-s-marketing" />
          <span slot="title">个股趋势</span>
        </el-menu-item>
        <el-menu-item index="index-trend">
          <i class="el-icon-data-line" />
          <span slot="title">指数趋势</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="theme-tagging">
          <i class="el-icon-price-tag" />
          <span slot="title">题材打标</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="theme-dict">
          <i class="el-icon-collection-tag" />
          <span slot="title">题材字典</span>
        </el-menu-item>
        <el-menu-item index="data-config">
          <i class="el-icon-setting" />
          <span slot="title">数据配置</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="users">
          <i class="el-icon-user" />
          <span slot="title">用户管理</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="sync-logs">
          <i class="el-icon-refresh" />
          <span slot="title">同步日志</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="login-logs">
          <i class="el-icon-time" />
          <span slot="title">登录历史</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container class="app-content">
      <el-header class="app-header">
        <div class="header-left">
          <el-button type="text" class="collapse-btn" @click="isCollapse = !isCollapse">
            <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" />
          </el-button>
          <span class="page-name">{{ pageTitle }}</span>
        </div>
        <div class="header-actions">
          <span class="user-label">{{ user.username }}</span>
          <el-button type="text" @click="$emit('logout')">退出登录</el-button>
        </div>
      </el-header>
      <el-main class="app-main">
        <slot />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'DesktopLayout',
  props: {
    user: { type: Object, required: true },
    activeMenu: { type: String, required: true },
    pageTitle: { type: String, required: true },
    isAdmin: { type: Boolean, default: false },
  },
  data() {
    return { isCollapse: false }
  },
  computed: {
    asideWidth() {
      return this.isCollapse ? '64px' : '220px'
    },
  },
}
</script>

<style scoped>
.app-layout {
  min-height: 100vh;
  width: 100%;
  display: flex !important;
}

.app-layout >>> .app-content {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  width: 0 !important;
  max-width: 100%;
}

.app-layout >>> .app-aside {
  flex-shrink: 0;
}

.app-content {
  display: flex;
  flex-direction: column;
}

.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
  height: 56px !important;
  padding: 0 24px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 4px;
}

.collapse-btn {
  font-size: 20px;
  color: #606266;
  padding: 0 8px;
}

.page-name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-label {
  font-size: 14px;
  color: #606266;
}

.app-aside.el-aside {
  position: sticky;
  top: 0;
  align-self: flex-start;
  height: 100vh;
  background: #1f2d3d;
  transition: width 0.2s ease;
  /* 关键：纵向 flex，品牌栏固定、菜单区自适应并可滚动，
     避免菜单项多于屏幕高度时被直接裁掉且无法滚动 */
  display: flex !important;
  flex-direction: column;
  overflow: hidden !important;
  box-sizing: border-box;
}

.app-aside >>> .side-menu {
  width: 100% !important;
  border-right: none;
  /* 菜单区占满剩余高度，内容超出时纵向滚动 */
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto !important;
}

/* 深色背景下的细滚动条，避免默认滚动条破坏侧栏视觉 */
.app-aside >>> .side-menu::-webkit-scrollbar {
  width: 6px;
}

.app-aside >>> .side-menu::-webkit-scrollbar-track {
  background: transparent;
}

.app-aside >>> .side-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 3px;
}

.app-aside >>> .side-menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.32);
}

/* 折叠态宽度仅 64px，滚动条会压住图标，隐藏但仍可滚动 */
.app-aside.is-collapse >>> .side-menu::-webkit-scrollbar {
  width: 0;
}

.app-aside >>> .side-menu.el-menu--collapse {
  width: 100% !important;
}

.brand {
  flex: 0 0 56px;
  height: 56px;
  line-height: 56px;
  padding: 0 20px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  white-space: nowrap;
  overflow: hidden;
}

.app-aside.is-collapse .brand {
  padding: 0;
  text-align: center;
}

.brand-short {
  font-size: 16px;
}

.app-main {
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 24px;
  background: #f5f7fa;
  text-align: left;
  overflow-x: auto;
}

.app-main >>> > * {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

</style>
